import { DEFAULT_INSTANCE_NAME } from '../types/constants';
export var normalizeInstanceName = function (instanceName) {
    return instanceName === undefined || instanceName === '' ? DEFAULT_INSTANCE_NAME : instanceName;
};
//# sourceMappingURL=instance-name.js.map